import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import { OpSenseToastContainer, toast } from "../Toast";
import { PageTitle } from '../PageTitle';
import AssetTypeForm from './asset_type_form';
import { Message } from '../Message';
import { AssetTypesService } from '../../services';
import { SubmissionError } from 'redux-form';

class AssetTypeAdd extends React.Component {
  constructor(props) {
    super(props);

    const assetType = {
      name: '',
      enterprise: this.props.me.enterprise
    };

    this.state = {
      added: null,
      assetType: assetType,
      enterprise: this.props.me.enterprise,
      errorMessage: null,
      localErrorMessage: null
    };
  }

  handleSubmit({name, requiresFloorplan, defaultTags, defaultAreaTag, measures, assetTypeMetadataTypes}) {
    let allDefaultTags = defaultTags ? defaultTags.map((tag) => { return ({ id: tag.value }); }) : [];
    if (defaultAreaTag) {
      allDefaultTags.push({ id: defaultAreaTag.value });
    }

    if (!measures) {
      toast.error(i18next.t("messages.please-select-at-least-one-measure"));
      throw new SubmissionError({measures: i18next.t("messages.please-select-at-least-one-measure")});
    }

    let assetType = {
      enterprise: {id: this.state.enterprise.id},
      name: name,
      requiresFloorplan: requiresFloorplan,
      defaultTags: allDefaultTags,
      measures: measures.map((measure) => { return ({
          name: measure.name,
          displayOrder: measure.displayOrder,
          deviceDataClassification: { id: measure.measureType.deviceDataClassification.id }
        });
      }),
      assetTypeMetadataTypes: assetTypeMetadataTypes ? assetTypeMetadataTypes.map((metadataType) => { return ({ 
          name: metadataType.name,
          stringValueFlag: metadataType.valueType === 'string',
          numericValueFlag: metadataType.valueType === 'numeric'
        });
      }) : []
    };

    AssetTypesService.add(assetType).then(assetType => {
      this.setState({ added: assetType });
    }).catch(error => {
      console.error(error);
      this.setState({ localErrorMessage: error.message });
    });
  }

  messageDismissCallback() {
    this.setState({ localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage) {
      return (
          <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    } else {
      return null;
    }
  }

  render() {
    if (this.state.errorMessage) {
      return (
          <Redirect to={{
            pathname: '/admin/asset-types',
            state: {
              errorMessage: this.state.errorMessage
            }
          }}/>
      );
    }

    if (this.state.added) {
      return (
          <Redirect to={{
            pathname: '/admin/asset-types',
            state: {
              from: this.props.location,
              successMessage: i18next.t('messages.asset-type-added')
            }
          }}/>
      );
    } else {
      if (this.state.assetType && this.state.enterprise) {
        const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
        return (
            <div>
              <OpSenseToastContainer />

              <div className="row">
                <PageTitle title={i18next.t('pages.asset-types.add-asset-type')}
                           backLinkWithParams={{
                             link: {
                               pathname: "/admin/asset-types",
                               search: backLinkSearch
                             }
                           }} />
              </div>

              {this.renderMessages()}

              <AssetTypeForm
                  onSubmit={this.handleSubmit.bind(this)}
                  errorMessage={this.props.errorMessage}
                  backLinkWithParams={{
                    link: {
                      pathname: "/admin/asset-types",
                      search: backLinkSearch
                    }
                  }}
              />
            </div>
        );
      } else {
        return (
            <div className="loader">{i18next.t('loading')}</div>
        );
      }
    }
  }
}

export default connect((state) => ({me: state.user.me}))(AssetTypeAdd);
